export default __webpack_public_path__ + "static/media/Shadow's Belt of the Tenth Court.43ecf273.jpg";